/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Machines_Col_ProgressInputs */

const vi_tea_machines_col_progress = /** @type {(inputs: Tea_Machines_Col_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiến độ (phút)`)
};

/**

* @param {Tea_Machines_Col_ProgressInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_machines_col_progress = /** @type {((inputs?: Tea_Machines_Col_ProgressInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Machines_Col_ProgressInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_machines_col_progress(inputs)
});